(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Ouvrir le menu' : 'Fermer le menu');
      mobileMenu.hidden = isOpen;
    });
    mobileMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        mobileMenu.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Ouvrir le menu');
      }
    });
  }

  const normalize = (value) => String(value || '').toLocaleLowerCase('fr-FR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const colorPalette = {
    noir: '#292622',
    beige: '#d7c7b5',
    gris: '#96928e',
    'blanc casse': '#f0ede5',
    blanc: '#f4f1e9'
  };

  document.querySelectorAll('[data-product-form-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const json = root.querySelector('[data-variants-json]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const groups = [...root.querySelectorAll('[data-option-group]')];
    const status = root.querySelector('[data-product-status]');
    const submit = root.querySelector('[data-product-submit]');
    const priceTargets = [...root.querySelectorAll('[data-product-price]')];
    const currency = root.dataset.currency || 'EUR';
    let variants = [];
    if (variantSelect) {
      variantSelect.tabIndex = -1;
      variantSelect.setAttribute('aria-hidden', 'true');
      const fallbackLabel = root.querySelector(`label[for="${CSS.escape(variantSelect.id)}"]`);
      fallbackLabel?.setAttribute('aria-hidden', 'true');
    }
    try { variants = JSON.parse(json?.textContent || '[]'); } catch (_) { variants = []; }

    const formatPrice = (cents) => {
      try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(Number(cents) / 100); }
      catch (_) { return `${(Number(cents) / 100).toFixed(2).replace('.', ',')} €`; }
    };
    const selectedOptions = () => groups.map((group) => group.querySelector('input[data-option-input]:checked')?.value || '');
    const currentVariant = () => {
      if (groups.length === 0) {
        const selectedId = variantSelect?.value;
        return variants.find((variant) => String(variant.id) === String(selectedId)) || variants.find((variant) => variant.available) || variants[0];
      }
      const selected = selectedOptions();
      return variants.find((variant) => (variant.options || []).length === selected.length && variant.options.every((value, index) => value === selected[index]));
    };

    const update = () => {
      const selected = selectedOptions();
      groups.forEach((group, optionIndex) => {
        group.querySelectorAll('input[data-option-input]').forEach((input) => {
          const trial = [...selected];
          trial[optionIndex] = input.value;
          const available = variants.some((variant) => variant.available && (variant.options || []).every((value, index) => value === trial[index]));
          input.disabled = !available;
          const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (label) label.setAttribute('aria-disabled', String(!available));
        });
        const selectedLabel = group.querySelector('[data-option-selected]');
        if (selectedLabel) selectedLabel.textContent = selected[optionIndex] || '';
      });

      const variant = currentVariant();
      if (variant && variantSelect) variantSelect.value = String(variant.id);
      if (variant && priceTargets.length) priceTargets.forEach((target) => { target.textContent = formatPrice(variant.price); });
      if (submit) submit.disabled = !variant || !variant.available;
      if (status) {
        if (!variant) status.textContent = 'Cette combinaison n’est pas disponible. Choisissez une autre option.';
        else if (!variant.available) status.textContent = 'Cette déclinaison est indisponible pour le moment.';
        else status.textContent = '';
      }
    };

    groups.forEach((group) => {
      group.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) update();
      });
      group.querySelectorAll('[data-option-input]').forEach((input) => {
        const swatch = input.parentElement.querySelector('[data-swatch-value]');
        if (swatch) {
          const key = normalize(swatch.dataset.swatchValue);
          swatch.style.setProperty('--swatch-color', colorPalette[key] || '#d7c7b5');
        }
      });
    });
    variantSelect?.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(variantSelect.value));
      if (variant) {
        groups.forEach((group, index) => {
          const input = [...group.querySelectorAll('[data-option-input]')].find((choice) => choice.value === variant.options[index]);
          if (input) input.checked = true;
        });
        update();
      }
    });
    form?.addEventListener('submit', (event) => {
      const variant = currentVariant();
      if (!variant || !variant.available) {
        event.preventDefault();
        if (status) status.textContent = 'Veuillez choisir une déclinaison disponible.';
      }
    });

    const fileInput = root.querySelector('[data-photo-upload]');
    const preview = root.querySelector('[data-upload-preview]');
    if (fileInput && preview) {
      let objectUrl = null;
      fileInput.addEventListener('change', () => {
        const file = fileInput.files?.[0];
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        preview.replaceChildren();
        if (!file) {
          preview.classList.remove('is-visible');
          return;
        }
        const name = document.createElement('span');
        name.textContent = file.name;
        preview.appendChild(name);
        if (file.type.startsWith('image/')) {
          objectUrl = URL.createObjectURL(file);
          const image = document.createElement('img');
          image.src = objectUrl;
          image.alt = '';
          preview.prepend(image);
        }
        preview.classList.add('is-visible');
      });
    }

    update();
  });

  document.querySelectorAll('[data-product-recommendations][data-url]').forEach((container) => {
    const url = container.dataset.url;
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((html) => {
        const documentFromResponse = new DOMParser().parseFromString(html, 'text/html');
        const updated = documentFromResponse.querySelector('[data-product-recommendations]');
        if (updated && updated.children.length) container.replaceWith(updated);
        else container.remove();
      })
      .catch(() => container.remove());
  });
})();
